import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import App from './App';
import './styles/index.css';
import './i18n';
import './config/axios.config'; // Configure axios interceptors
import { installResilientFetch } from './lib/resilientFetch';
import { initializeTracking } from './services/trackingService';
import { queryClient } from './lib/queryClient';

// Every API request gets fresh-token injection, 401 refresh+replay and
// read retries on network blips (see lib/resilientFetch.ts).
installResilientFetch();

// Initialize user tracking for analytics
initializeTracking();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </React.StrictMode>
);
